'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ChatBubble = require('ui-addon-messages/chat-message/ChatBubble');

var _ChatBubble2 = _interopRequireDefault(_ChatBubble);

var _MessageWrapper = require('../MessageWrapper');

var _MessageWrapper2 = _interopRequireDefault(_MessageWrapper);

var _AutomatedChatMessageBotAvatar = require('../AutomatedChatMessageBotAvatar');

var _AutomatedChatMessageBotAvatar2 = _interopRequireDefault(_AutomatedChatMessageBotAvatar);

var _pubnubMessageGetters = require('conversations-schema/pubnub-message/operators/pubnubMessageGetters');

var _getAccentColor = require('conversations-schema/operators/coloring/getAccentColor');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  coloring: (0, _RecordPropType2.default)('ColoringRecord').isRequired,
  message: (0, _RecordPropType2.default)('PubNubMessageRecord').isRequired
};

var EmailCaptureChatBubble = function EmailCaptureChatBubble(_ref) {
  var coloring = _ref.coloring,
      message = _ref.message;

  return _react2.default.createElement(
    _MessageWrapper2.default,
    {
      avatar: _react2.default.createElement(_AutomatedChatMessageBotAvatar2.default, { color: (0, _getAccentColor.getAccentColor)(coloring) })
    },
    _react2.default.createElement(
      _ChatBubble2.default,
      {
        className: 'email-capture-chat-bubble',
        align: _ChatBubble.alignment.LEFT,
        isFirstInGroup: true,
        isLastInGroup: false
      },
      (0, _pubnubMessageGetters.getText)(message)
    )
  );
};

EmailCaptureChatBubble.propTypes = propTypes;

exports.default = EmailCaptureChatBubble;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/emailCapture/EmailCaptureChatBubble.js
// module id = 1092
// module chunks = 2 3